import { createReducer, on } from "@ngrx/store";
import { addTipoComprobantes, addTipoComprobantesError, clearTipoComprobantes, deleteTipoComprobante, updateTipoComprobante } from "../actions/tipoComprobante.actions";
import { initialTipoComprobantesState } from "../../core/interfaces/models/tipoComprobante.interface";

export const comprobanteReducer = createReducer(
  initialTipoComprobantesState,
  on(addTipoComprobantes, (_, { tipoComprobantesState }) => (
    tipoComprobantesState
  )),
  on(addTipoComprobantesError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateTipoComprobante, (state, { tipoComprobante }) => ({
    ...state,
    tipoComprobantes: state.tipoComprobantes.map(u =>
      u.id === tipoComprobante.id ? tipoComprobante : u
    )
  })),
  on(deleteTipoComprobante, (state, { id }) => ({
    ...state,
    tipoComprobantes: state.tipoComprobantes.filter(u => u.id !== id)
  })),
  on(clearTipoComprobantes, () => initialTipoComprobantesState)
)
